$(window).on("load", function () {
	$(`#navbar a`).attr("draggable", "false");
	$(`#navbar img`).attr("draggable", "false");

	$("#goToTop").on("click", function() {
		$("html, body").animate({ scrollTop: 0 }, 250);
	});
});